import {
  ChatIcon,
  ConferencesIcon,
  FileIcon,
  HonorariumIcon,
  TaxIcon,
  ReferralIcon,
} from "@/ui/icons";

export interface NavItem {
  title: string;
  path: string;
  icon: any;
  isMobileCompatible: boolean;
}

export const navigationConfig: Record<string, NavItem[]> = {
  "liberty-ai": [
    {
      title: "LibertyAI Beta",
      path: "/liberty-ai",
      icon: ChatIcon,
      isMobileCompatible: true,
    },
  ],
  board: [
    {
      title: "Conferences",
      path: "/board/conferences",
      icon: ConferencesIcon,
      isMobileCompatible: true,
    },
    {
      title: "Documents",
      path: "/board/documents",
      icon: FileIcon,
      isMobileCompatible: true,
    },
  ],
  honorarium: [
    {
      title: "Honorarium",
      path: "/honorarium/conferences",
      icon: HonorariumIcon,
      isMobileCompatible: true,
    },
  ],
  people: [
    {
      title: "Referrals",
      path: "/people/referrals",
      icon: ReferralIcon,
      isMobileCompatible: true,
    },
  ],
  "tax-forms": [
    {
      title: "Tax Forms",
      path: "/tax-forms/conferences",
      icon: TaxIcon,
      isMobileCompatible: false,
    },
  ],
};

/** Stable sidebar order for role-derived app sections. */
export const navigationAppOrder = Object.keys(navigationConfig);

export function orderNavigationApps(appNames: string[]): string[] {
  return [...appNames].sort((a, b) => {
    const aIndex = navigationAppOrder.indexOf(a);
    const bIndex = navigationAppOrder.indexOf(b);
    const aRank = aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex;
    const bRank = bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex;
    return aRank - bRank;
  });
}
